// extracted by mini-css-extract-plugin
module.exports = {"title":"title__3lJ83","form":"form__uKq8c","textarea":"textarea__3GA3M","modal":"modal__3tyhm"};